<template>
    <div id="main">
        <div class="page">
            <div class="sc-cidade">
                <h1 class="title">{{ $t('status-comercial-cliente') }} </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a>{{$t('vendas')}}</a></li>
                        <li><a>{{$t('geoanalise')}}</a></li>
                        <li><a href="#" aria-current="page">{{$t('status-comercial-cliente')}}</a></li>
                    </ul>
                </nav>
                
                <!-- Mapa -->
                <div class="mapa-wrapper" :class="{'disabled': isLoading}">
                    <gmap-map  
                        ref="mapRef"
                        :center="center"
                        :zoom="zoomLevel"
                        :options="mapOptions"
                        @zoom_changed="checkIfOpenedWindowInCluster"
                    >
                        <gmap-info-window
                            ref="infoWindow"
                            :position="infoWindow.position"
                            :opened="infoWindow.open"
                            @closeclick="infoWindow.open = false"
                        >
                            <div class="info-window">
                                <p class="info-window-nome">{{infoWindow.item.rsocial}}</p>
                                <div class="info-details">
                                    <span>
                                        {{$t('endereco-do-promotor')}}
                                        {{infoWindow.item.endereco}}{{infoWindow.item.numero ? ', ' + infoWindow.item.numero : ''}}
                                        {{infoWindow.item.bairro ? ' - ' + infoWindow.item.bairro : ''}}
                                    </span>
                                    <br>
                                    <div v-if="infoWindow.item.cidade">
                                        {{$t('cidade-do-promotor')}}
                                        {{infoWindow.item.cidade.descricao}}{{infoWindow.item.estado ? ' - ' + infoWindow.item.estado.descricao : ''}}
                                    </div>
                                    
                                    <div v-if="infoWindow.item.regiao">
                                        {{$t('regiao')}}:
                                        {{infoWindow.item.regiao.descricao}}
                                    </div>
                                    
                                    <div v-if="infoWindow.item.atividade">
                                        {{$t('atividade')}}:
                                        {{infoWindow.item.atividade.descricao}}
                                    </div>
                                    <b-collapse
                                        :open.sync="infoWindow.detailsOpen"
                                    >
                                        <button class="btn-expand" slot="trigger" @click="toggleDetails">
                                            {{$t('detalhes')}}
                                            <b-icon
                                                :icon="infoWindow.detailsOpen ? 'menu-up' : 'menu-down'"
                                                size="is-small">
                                            </b-icon>
                                        </button>

                                        <div v-if="infoWindow.item.datafundacao != '' && infoWindow.item.datafundacao != undefined">
                                            <span>{{$t('fundacao')}}:</span>
                                            <span class="item-detail">{{getDate(infoWindow.item.datafundacao)}}</span>
                                        </div>

                                        <span>{{$t('titulos')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.titulosvencidos + ' ' + $t('vencidos')}}</span>
                                        <br>
                                        <span class="item-detail">{{infoWindow.item.titulosavencer + ' ' + $t('a-vencer')}}</span>
                                        <br>

                                        <span>{{$t('qtd-nao-vendas')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.qtdnaovenda}}</span>
                                        <br>

                                        <span>{{$t('qtd-tomada-preco')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.qtdtomadadepreco}}</span>
                                        <br>

                                        <span>{{$t('qtd-contatos')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.qtdcontatos}}</span>
                                        <br>

                                        <span>{{$t('latitude')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.latitude}}</span>
                                        <br>

                                        <span>{{$t('longitude')}}:</span>
                                        <span class="item-detail">{{infoWindow.item.longitude}}</span>
                                    </b-collapse>
                                </div>
                                <!-- Botão abrir cadastro -->
                                <!-- <button class="btn-cadastro">{{$t('abrir-cadastro')}}</button> -->
                            </div>
                        </gmap-info-window>
                    </gmap-map>
                </div>

                <!-- Botão de retrair -->
                <div 
                    ref="retractBtn"
                    class="retract-button"
                    :class="{'hide-control-right-btn': !showStatus}"
                    v-show="!isLoading && !$root.gmapsFailure"
                >
                    <div class="btn-wrapper" @click="showStatus = !showStatus">
                        <b-icon :icon="showStatus ? 'chevron-right' : 'chevron-left'"/>
                    </div>
                </div>
                <!-- Lista de Status - Dentro do Mapa -->
                <div 
                    ref="listaStatus"
                    class="control-right"
                    :class="{'hide-control-right': !showStatus}"
                    v-show="!isLoading && !$root.gmapsFailure"
                >
                    <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
                    <alert-container :messages="msgs"/>
                    <div class="control-container">
                        <!-- Abas -->
                        <div class="control-tabs">
                            <ul class="nav nav-tabs">
                                <li
                                    v-for="(a, i) in abas"
                                    :class="{'active': abaAtual == i}"
                                    :key="i"
                                    @click="abaAtual = i"
                                >
                                    <a data-toggle="tab" href="#">{{$t(a)}}</a>
                                </li>
                            </ul>
                        </div>
                        <!-- Aba Clientes -->
                        <div class="lista-status" v-show="abaAtual == 0">
                            <search-bar class="search-input" :onSearch="debouncedOnSearch" disableTeste />
                            <div class="table-controls">
                                <div class="status-header" :class="{'ordered': isOrderedBy == 'nome', 'disabled': isSearching}" @click="orderBy('nome', sortDirection, true)" >
                                    {{ $t('status-comercial') }}
                                    <svg class="svg-icons" v-if="isOrderedBy == 'nome' && sortDirection == false">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-up.svg')+'#layer'"></use>
                                    </svg>
                                    <svg class="svg-icons" v-if="isOrderedBy == 'nome' && sortDirection == true">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-down.svg')+'#layer'"></use>
                                    </svg>
                                </div>
                                <div class="cliente-header" :class="{'ordered': isOrderedBy == 'qtd', 'disabled': isSearching}" >
                                    {{ $t('clientes') }}
                                    <svg class="svg-icons" v-if="isOrderedBy == 'qtd' && sortDirection == false">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-up.svg')+'#layer'"></use>
                                    </svg>
                                    <svg class="svg-icons" v-if="isOrderedBy == 'qtd' && sortDirection == true">
                                        <use :xlink:href="require('@/assets/img/icons/arrow-down.svg')+'#layer'"></use>
                                    </svg>
                                </div>
                            </div>
                            <div class="columns lista-wrapper is-mobile">
                                <div class="column is-paddingless lista-container">
                                    <div class="columns is-multiline is-mobile" :class="isSearching ? 'disabled' : ''">
                                        <div class="column is-full lista-item" v-for="(s, i) in status" :key="i" :class="s.isLoading ? 'disabled' : ''">
                                            <div class="status-info">
                                                <div class="info-left">
                                                    <b-icon icon="circle" size="is-small" :style="`color: ${s.qtd > 0 ? s.cor : '#999999'}; width: 10px;`"/>
                                                    <div class="check-div">
                                                        <label class="check-box" v-show="s.qtd > 0">
                                                            <input 
                                                                :ref="`chk-${s.tipo}`"
                                                                type="checkbox" 
                                                                v-model="visibilityMap[s.tipo].checked" 
                                                                @change="toggleStatus(s)"/>
                                                            <span class="checkmark"/>
                                                        </label>
                                                    </div>
                                                    <div 
                                                        @click="openDetails(s)"
                                                        :style="s.qtd == 0 ? 'padding-right: 16px;' : ''"
                                                    >
                                                        <b-icon
                                                            :icon="s.detailsOpen ? 'chevron-down' : 'chevron-right'"
                                                            size="is-small"
                                                            custom-size="mdi-18px"
                                                            v-if="s.qtd > 0"
                                                        />
                                                    </div>
                                                    <div style="width: 100%" @click="openDetails(s)">
                                                        <span>
                                                            {{ s.descricao.toUpperCase() }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="info-right" @click="openDetails(s)">
                                                    {{ s.qtd }} - {{ format(totalClientes > 0 ? s.qtd / totalClientes : 0) }}
                                                </div>
                                            </div>
                                            <b-collapse 
                                                :open="s.detailsOpen"
                                            >
                                                <div class="column is-full lista-clientes" v-for="(c,i) in s.clients" :key="i">
                                                    <div class="status-info">
                                                        <div class="info-left">
                                                            <label class="check-box">
                                                                <input type="checkbox" v-model="visibilityMap[s.tipo][c.idcliente].visible" @change="toggleStatusClient(s, c)"/>
                                                                <span class="checkmark"/>
                                                            </label>
                                                            <span class="text">
                                                                {{ c.rsocial }}
                                                                <br>
                                                                {{ $t('ultima-compra-em') + ' ' + $moment(c.ultimavenda).format("L") }}
                                                                <br>
                                                                {{ $t('sem-compra-a-n-dias', { n: c.diferencadias }) }}
                                                                <br>
                                                                {{ $t('vendedor-abrev') + ': ' + c.vendedor }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-count">
                                <div v-if="!isLoading" :class="isSearching ? 'disabled' : ''">
                                    {{$t('clientes')}}: {{ totalClientes }}
                                </div>
                            </div>
                        </div>
                        <!-- Aba Filtros -->
                        <div class="filtros-main" v-show="abaAtual == 1">
                            <label v-text="$t('atividade')"/>
                            <v-select
                                class="smaller"
                                @search="loadAtividades"
                                :options="atividades"
                                :disabled="isSearching"
                                v-model="atividade"
                            >
                                <template
                                    slot="no-options"
                                >{{$t('sem-resultados-filtro')}}</template>
                            </v-select>
                            <label v-text="$t('regiao')"/>
                            <v-select
                                class="smaller"
                                @search="loadRegioes"
                                :options="regioes"
                                :disabled="isSearching"
                                v-model="regiao"
                            >
                                <template
                                    slot="no-options"
                                >{{$t('sem-resultados-filtro')}}</template>
                            </v-select>
                            <vss-select
                                title="situacao"
                                class="smaller"
                                @search="loadSituacoes"
                                :options="situacoes"
                                :disabled="isSearching"
                                :closeOnSelect="false"
                                v-model="situacao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                tooltipLabel="situacao-incluidos-inativos"
                                tooltipSize="is-small"
                                multiple
                                clearable
                                searchable
                            />
                        </div>
                        <div class="filter-footer-right p-5-custom is-flex is-flex-hright">
                            <b-button
                                type="is-silver"
                                icon-right="backspace"
                                @click="removeFilter"
                                class="mr-2"
                                :disabled="isLoading"
                            >
                                {{ $t('limpar') }}
                            </b-button>
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="applyFilter"
                                :disabled="isLoading"
                            >
                                {{ $t('filtrar') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeoanaliseService from "@/services/GeoanaliseService";
import FiltroRelatorioService from "@/services/FiltroRelatorioService";
import SituacaoService from "@/services/SituacaoService";
import Cluster from 'vue2-google-maps/src/components/cluster';
import paleta from "@/functions/color/paleta.js";
import Message from "@/models/Message";
import MarkerClusterer from 'marker-clusterer-plus';

export default {
    components: {
        Cluster,
    },
    data() {
        return {
            situacaoService: new SituacaoService(this.$http, this.$router),
            cluster: null,
            center: {lat: -15, lng: -50},
            zoomLevel: 4,
            isLoading: true,
            abas: ['clientes', 'filtros'],
            abaAtual: 0,
            status: [],
            cMarkers: [],
            filteredMarkers: [],
            visibilityMap: {},
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                detailsOpen: false,
                item: {}
            },
            isSearching: false,
            colors: [],
            totalClientes: 0,
            clusterOptions: {
                maxZoom: 12,
                zoomOnClick: true,
                minimumClusterSize: 2,
                styles: [{
                    textColor: 'white',
                    url: '',
                    fontFamily: 'Montserrat,sans-serif',
                    fontWeight: 'normal',
                    height: 45,
                    width: 45
                }]
            },
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    position: 7 // google.maps.ControlPosition.RIGHT_TOP
                }
            },
            svgpath: "M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z",
            msgs: [],
            showStatus: true,
            isOrderedBy: '',
            sortDirection: null, // false == Ascendente, true == Descendente.
            filtro: {},
            searchVal: '',
            atividades: [],
            atividade: null,
            situacoes: [],
            situacao: null,
            regioes: [],
            regiao: null,
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'relatorio-geoanalise', 'mapa-status-comercial-cliente');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'status-comercial-cliente' },
        });

        this.isLoading = true;
        this.colors = paleta.colorList;
        this.service = new GeoanaliseService(this.$http, this.$router);
        this.filterService = new FiltroRelatorioService(this.$http, this.$router);

        this.debouncedOnSearch = this.debounce(this.searchClientes, 500);
        this.loadAtividades('');
        this.loadRegioes('');
        this.loadSituacoes();
    },
    mounted () {
        this.$refs.mapRef.$mapPromise.then(map => {
            this.service
                .findAllClient({}, '')
                .then(this.getMarkers)
                .then(this.mapItemsStatus)
                .then(body => {
                    this.status = body;
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.msgs.push(
                        new Message("error", 'msg-erro-relatorio', true)
                    );
                    console.error('Erro ao carregar clientes:');
                    console.error(error);
                });

            this.clusterOptions.styles[0].url = this.getMapClusterSvg();
            this.cluster = new MarkerClusterer(this.$refs.mapRef.$mapObject, [], this.clusterOptions);

            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.listaStatus);

            setTimeout(() => {
                this.gmnoprintZindex();
            }, 1000);
        });
    },
    methods: {
        removeFilter() {
            this.situacao = null;
            this.regiao = null;
            this.atividade = null;

            this.applyFilter();
        },
        loadSituacoes(){
            this.situacaoService.findAllVendas("descricao", "desc", 0, 50, 1)
             .then(this.mapItemsSituacao)
                      .then(r => {
                          this.situacoes = r;
                       
                      });
        },
        mapItemsSituacao (body) {
            let list = body.content.map(i => {
                return {
                    id: i.idsituacao,
                    label: i.descricao
                };
            });

            return list;
        },
        toggleStatus (s) {
            this.visibilityMap[s.tipo].visible = this.visibilityMap[s.tipo].checked;

            for (var c in this.visibilityMap[s.tipo]) {
                if (c != 'visible' && c != 'checked') {
                    this.visibilityMap[s.tipo][c].visible = this.visibilityMap[s.tipo].visible;
                }
            }

            if (this.infoWindow.open && (this.infoWindow.item.tipo == s.tipo)) {
                this.infoWindow.open = false;
            }

            this.updateMarkers();
        },
        toggleStatusClient(s, c) {
            let visible = 0, invisible = 0;

            s.clients.forEach(c => {
                this.visibilityMap[s.tipo][c.idcliente].visible ? visible++ : invisible++;
            });

            if (this.infoWindow.open && (this.infoWindow.item.idcliente == c.idcliente)) {
                this.infoWindow.open = false;
            }

            this.visibilityMap[s.tipo].checked = visible > 0;
            this.visibilityMap[s.tipo].visible = visible > 0;

            this.$refs[`chk-${s.tipo}`][0].indeterminate = visible > 0 && invisible > 0;

            this.updateMarkers();
        },
        openDetails(s) {
            if (!s.isLoading) {
                if (s.hasDetails) {
                    s.detailsOpen = !s.detailsOpen;
                } else {
                    s.isLoading = true;
                    return this.service.findByStatusClient(s.tipo, this.filtro, this.searchVal)
                        .then(this.mapItems)
                        .then(c => {
                            s.clients = c;
                            if (this.isOrderedBy){
                                this.orderBy(this.isOrderedBy, this.sortDirection, false, s.clients);
                            }
                            s.hasDetails = true;
                            s.detailsOpen = true;
                            s.isLoading = false;
                            this.toggleStatus(s);
                        });
                }
            }
        },
        getLabel (option) {
            return this.$t(option.label);
        },
        getCorStatus (tipo) {
            switch (tipo) {
                case 'A':
                    return this.colors[9];
                case 'N':
                    return this.colors[5];
                case 'I':
                    return this.colors[0];
                case 'QI':
                    return this.colors[14];
                case 'R':
                    return this.colors[12];
            }
        },
        format (number) {
            return number.toLocaleString(undefined, 
                {
                    style: 'percent',
                    minimumFractionDigits: 0, 
                    maximumFractionDigits: 2
                }
            );
        },
        getDate (d) {
            if (d != '' && d != undefined) {
                let date = new Date(d);
                return date.toLocaleDateString();
            } else {
                return '';
            }
        },
        getMarkers (body) {
            let m = [];

            body.forEach(s => {
                this.visibilityMap[s.tipo] = {};
                this.visibilityMap[s.tipo].visible = true;
                this.visibilityMap[s.tipo].checked = true;

                s.clients.forEach(c => {
                    this.visibilityMap[s.tipo][c.idcliente] = {};
                    this.visibilityMap[s.tipo][c.idcliente].visible = true;
                    this.visibilityMap[s.tipo][c.idcliente].inSearch = true;

                    let self = this;
                    let marker = new google.maps.Marker({
                        idcliente: c.idcliente,
                        status: s.tipo,
                        visible: true,
                        position: {
                            lat: c.latitude,
                            lng: c.longitude
                        },
                        icon: {
                            path: this.svgpath,
                            fillColor: this.getCorStatus(s.tipo),
                            scale: 1,
                            fillOpacity: 1,
                            strokeWeight: 0,
                            anchor: {x: 10, y: 25}
                        }
                    });

                    marker.addListener('click', function () {
                        self.openInfo(marker);
                    });

                    m.push(marker);
                });
            });

            this.cMarkers = m;
            this.filteredMarkers = m;

            this.$refs.mapRef.$mapPromise.then(map => {
                let bounds = new google.maps.LatLngBounds();
                
                this.cMarkers.forEach(m => {
                    bounds.extend(m.position);
                });

                map.fitBounds(bounds);
                this.cluster.addMarkers(this.filteredMarkers, true);
            });

            return body;
        },
        getMarkersSearch (body) {
            this.cMarkers = [];

            body.forEach(s => {
                s.clients.forEach(c => {
                    let self = this;

                    let marker = new google.maps.Marker({
                        idcliente: c.idcliente,
                        status: s.tipo,
                        visible: true,
                        position: {
                            lat: c.latitude,
                            lng: c.longitude
                        },
                        icon: {
                            path: this.svgpath,
                            fillColor: this.getCorStatus(s.tipo),
                            scale: 1,
                            fillOpacity: 1,
                            strokeWeight: 0,
                            anchor: {x: 10, y: 25}
                        }
                    });

                    marker.addListener('click', function () {
                        self.openInfo(marker);
                    });

                    this.cMarkers.push(marker);
                });
            });

            this.updateMarkers();
            
            return body;
        },
        mapItemsStatus (body) {
            let total = 0;

            body.forEach(c => {
                total += c.clients.length;
            });

            this.totalClientes = total;

            return body.map(s => {
                s.clients.forEach(c => {
                    this.visibilityMap[s.tipo][c.idcliente].inSearch = true;
                });

                return {
                    descricao: s.descricao,
                    tipo: s.tipo,
                    clients: [],
                    cor: this.getCorStatus(s.tipo),
                    qtd: s.clients.length,
                    hasDetails: false,
                    detailsOpen: false,
                    isLoading: false
                }
            });
        },
        mapClientsId (clients) {
            return clients.map(c => {
                return { idcliente: c.idcliente };
            });
        },
        mapItems (body) {
            return body.clients.map(s => {
                return {
                    idcliente: s.idcliente,
                    rsocial: s.rsocial,
                    endereco: s.endereco,
                    numero: s.numero,
                    bairro: s.bairro,
                    cidade: s.cidade ? s.cidade.descricao : '',
                    estado: s.estado ? s.estado.descricao : '',
                    regiao: s.regiao ? s.regiao.descricao : '',
                    atividade: s.atividade ? s.atividade.descricao : '',
                    datafundacao: s.datafundacao,
                    titulosvencidos: s.titulosvencidos,
                    titulosavencer: s.titulosavencer,
                    naovendas: s.qtdnaovenda,
                    tomadapreco: s.qtdtomadadepreco,
                    contatos: s.qtdcontatos,
                    lat: s.latitude,
                    lng: s.longitude,
                    ultimavenda: s.dataultimavenda,
                    diferencadias: s.diferencadias,
                    vendedor: s.vendedor       
                }
            })
        },
        openInfo (m) {
            this.infoWindow.open = false;
            if (m.idcliente > 0) {
                this.service.findClientById(m.idcliente)
                    .then(r => {
                        if (r.clients && r.clients.length > 0) {
                            this.infoWindow.position = m.position;
                            this.$nextTick(() => { this.infoWindow.open = true; });
                            this.infoWindow.item = r.clients[0];
                            this.infoWindow.item.tipo = m.status;
                        }
                    });
            }
        },
        toggleDetails() {
            // Recentraliza a info window ao abrir os detalhes
            this.$refs.mapRef.$mapPromise.then(map => {
                this.$refs.infoWindow.$infoWindowPromise.then(iw => {
                    iw.open(map);
                });
            });
        },
        updateMarkers () {
            this.filteredMarkers = this.cMarkers.filter(m => {
                return this.visibilityMap[m.status][m.idcliente].visible && this.visibilityMap[m.status][m.idcliente].inSearch;
            });

            this.cluster.clearMarkers();
            this.cluster.addMarkers(this.filteredMarkers);
            this.$forceUpdate();
        },
        orderBy (field, direction, changeSortDirection, list = []){
            this.isOrderedBy = field;
            if (direction == null){
                this.sortDirection = false;
                direction = false;
            } else if (changeSortDirection) {
                this.sortDirection = !direction;
            }

            if (field == 'nome'){
                if (list.length <= 0){
                    this.status.forEach((sc) => {
                        if (sc.clients.length > 0 && sc.clients[0].rsocial){
                            sc.clients.sort(this.compareRS);
                        }
                    });
                } else {
                    list.sort(this.compareRS);
                }
            } else if( field == 'qtd'){

            }
        },
        compareRS(a, b){
            if (!this.sortDirection){ // Ascendente
                if (a.rsocial < b.rsocial){
                    return -1;
                } 
                if (a.rsocial > b.rsocial){
                    return 1;
                }
            } else { // Descendente
                if (a.rsocial < b.rsocial){
                    return 1;
                } 
                if (a.rsocial > b.rsocial){
                    return -1;
                }
            }
            return 0;
        },
        checkIfOpenedWindowInCluster () {
            if (this.infoWindow.open) {
                let cliente = this.infoWindow.item.idcliente;

                setTimeout(() => {
                    this.cluster.getClusters().forEach(c => {
                        if (c.markers_.length > this.clusterOptions.minimumClusterSize - 1) {
                            c.markers_.some(m => {
                                if (m.idcliente == cliente) {
                                    this.infoWindow.open = false;
                                }
                                return m.idcliente == cliente;
                            });
                        }
                    });
                }, this.cMarkers.length * 0.2);
            }
        },
        loadAtividades (val) {
            this.filterService.findAllAtividade(0, 50, val)
                      .then(this.mapItemsFiltro)
                      .then(r => {
                          this.atividades = r;
                      });
        },
        loadRegioes (val) {
            this.filterService.findAllRegiao(0, 50, val)
                      .then(this.mapItemsFiltro)
                      .then(r => {
                          this.regioes = r;
                      });
        },
        mapItemsFiltro (body) {
            let list = body.content.map(i => {
                return {
                    id: i.id,
                    label: i.descricao
                };
            });

            return list;
        },
        applyFilter () {
            this.isSearching = true;

            this.filtro = {
                atividade: this.atividade != null ? {descricao: this.atividade.label} : null,
                situacao: this.situacao != null ? this.situacao.map((situacao) => ({idsituacao: situacao.id})) : null,
                regiao: this.regiao != null ? {descricao: this.regiao.label} : null
            };

            this.searchClientes(this.searchVal);
        },
        searchClientes (val) {
            let requests = [];

            this.isSearching = true;
            this.searchVal = val;

            for (var s in this.visibilityMap) {
                if (s != 'visible') {
                    for (var c in this.visibilityMap[s]) {
                        if (c != 'visible' && c != 'checked') {
                            this.visibilityMap[s][c].inSearch = false;
                        }
                    }
                }
            }

            this.status.forEach(s => {
                if (s.hasDetails) {
                    requests.push(
                        this.service.findByStatus(s.tipo, this.filtro, this.searchVal)
                            .then(this.mapItems)
                            .then(r => {
                                s.clients = r;
                            })
                    );
                }
            });

            requests.push(
                this.service.findAll(this.filtro, val)
                    .then(this.mapItemsStatus)
                    .then(r => {
                        let recstatus = [];

                        this.status.forEach((s, i) => {
                            recstatus = r.find(sr => sr.tipo == s.tipo);

                            if (recstatus != undefined) {
                                s.qtd = recstatus.qtd;
                                
                                this.$nextTick(function() {
                                    let chk = this.$refs[`chk-${s.tipo}`];
                                    let visible = 0, invisible = 0;
                                    
                                    for (var c in this.visibilityMap[s.tipo]) {
                                        if (c != 'visible' && c != 'checked' && this.visibilityMap[s.tipo][c].inSearch) {
                                            this.visibilityMap[s.tipo][c].visible ? visible++ : invisible++;
                                        }
                                    }

                                    chk[0].indeterminate = visible > 0 && invisible > 0;
                                    
                                    this.visibilityMap[s.tipo].checked = this.visibilityMap[s.tipo].visible && visible > 0;
                                });
                            }
                        });
                    })
            );

            // Executado quando todas as requests resolverem
            Promise.all(requests).then(() => {
                this.updateMarkers();
                this.orderBy(this.isOrderedBy, this.sortDirection, false);
                this.isSearching = false;
            });
        },
        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach(e => {    
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        }
    }
};
</script>

<style lang="scss">

.search-input .search-wrapper {
    width: 100%;
    height: 27px !important; 
    border: 1px solid #e1e1e1;
    display: flex;
    position: relative;
    border-radius: 3px;
}
@mixin border() {
    border: 1px solid $table-border;
    border-radius: 3px;
}

.p-5-custom {
    padding: 10px;
}

#main {
    padding: 0px 20px;
    height: 100%;
}

.page {
    position: relative;
}

h1.title {
    margin-right: 0;
    margin-bottom: 0;
}

.mapa-wrapper {
    .vue-map-container {
        width: 100%;
        height: calc(100vh - 140px);
    }
}

.control-right {
    .lista-status {
        width: 100%;
        height: calc(100% - 40px);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding: 0.75rem;

        .search-input {
            opacity: 0.9;
        }

        .table-controls {
            display: flex;
            border: 1px solid $table-border;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom: 0;
            height: 1.5rem;
            margin-top: 0.4rem;
            align-items: center;
            font-weight: 600;

            .status-header {
                display: flex;
                align-items: center;
                width: 70%;
                padding-left: 22px;
                justify-content: space-between;
                height: 100%;
                cursor: pointer;

                &:hover{
                    background: $table-border;
                }
            }

            .cliente-header {
                display: flex;
                align-items: center;
                width: 30%;
                justify-content: center;
                height: 100%;

                // &:hover{
                //     background: $table-border;
                // }
            }
        }

        .lista-wrapper {
            height: calc(100% - 4rem);
            margin-bottom: -0.75rem;

            .lista-container {
                border-left: 1px solid $table-border;
                border-right: 1px solid $table-border;
                margin: 0.75rem;
                overflow-y: scroll;

                &>.columns.is-multiline {
                    margin: 0;
                }

                .lista-item, .lista-clientes {
                    cursor: pointer;

                    .status-info {
                        display: flex; 

                        .info-left {
                            display: flex;
                            align-items: center;

                            .check-div {
                                width: 20px;
                                height: 20px;
                                margin-left: 7px;
                            }

                            .text {
                                padding-left: 5px;
                            }
                        }

                        .info-right {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            width: 100px;
                        }
                    }
                }

                .lista-item {
                    padding: 0.25rem;

                    .status-info .info-left {
                        width: calc(100% - 100px);
                    }
                }

                .lista-clientes {
                    padding: 0.25rem 0 0.25rem 1.75rem;

                    .status-info .info-left {
                        width: 100%;
                        align-items: flex-start;
                    }
                }
            }
        }

        .table-count {
            display: flex;
            border: 1px solid $table-border;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            height: 1.5rem;
            align-items: center;
            justify-content: space-around;
            font-weight: 600;
        }
    }
}

.item-detail {
    float: right;
}

@mixin btn () {
    width: 100%;
    padding: 5px;
    margin: 5px 0px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border: none;
    border-radius: 3px;
    outline: none;
}

.btn-expand {
    color: $darker-gray-color;
    @include btn();

    &:active{
        background-color: $darker-bg-color;
    }

    &:hover, &:focus{
        background-color: $table-border;
    }
}

.btn-cadastro {
    background-color: $primary-color;
    color: $sovis-white;
    @include btn();

    &:active{
        background-color: $primary-color-click;
    }

    &:hover, &:focus{
        background-color: $primary-color-hover;
    }
}

.check-box {
    margin-bottom: 0;
    // margin-left: 5px;

    .checkmark {
        position: inherit;
        display: inline-flex;
        top: 0;
        right: 0;
        height: 16px;
        width: 16px;
        border: 2px solid $primary-color-hover;
        margin-top: 2px;
        border-radius: 3px;
    }
}
</style>